import { FirestoreQueryBuilder } from '../../../../lib/gcp/builder/firestore-query.builder';
import { IRepository } from '../../../../utility/repository/repository';
import { Observable } from 'rxjs';
import { SlackChannel } from '../entity';
import { SlackChannelId } from '../value';

export abstract class ISlackChannelRepository extends IRepository<SlackChannelId, SlackChannel> {
  abstract selectAll(builder: FirestoreQueryBuilder<SlackChannel>): Observable<SlackChannel>;
  abstract selectIfExists(id: SlackChannelId): Observable<SlackChannel> | null;
}
